import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.viewerComponentName), _mergeProps(_ctx.$props, {
      onViewerClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewerClose'))),
      onDownload: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('fileDownload')))
    }), null, 16))
  ]))
}